export default "__VITE_ASSET__DX4z01ly__"